import { createContext } from 'react'

export const ColorModeContext = createContext({
  toggleColorMode: () => {
    /*noop*/
  },
})
